import React, { useEffect, useRef, useState } from "react";
import { Definition } from "../../../../../../data/Definition";
import Stats from "../../../../components/Elements/Stats";
import Widget from "../../../../components/Elements/Widget";
import { useStore } from "../../../../providers/AppProvider";
import { Field, StatValue } from "../../../../types/types";
import { queryDwMetric, queryDwFieldVVIcVariance, queryDwFieldChange } from "../../../../utils/dwHelpers";
import { SETTING_SEASON_YEAR } from "../../../../utils/settings";
import { dcRound } from "../../../../utils/misc";

const CACHE_SIZE = 20;

interface FieldStatTableProps {
    field: Field;
    name: string;
    description: string;
    metric: 'productivity' | 'stress';
    changeInverted?: boolean;
    selectedDate: string | null;
}

const FieldStatTable = ({ field, name, description, metric, changeInverted=false, selectedDate }: FieldStatTableProps) => {
    const { state, loading, settings } = useStore();
    const [updateSelctorIncrement, setUpdateSelctorIncrement] = useState<number>(0);
    const [dataStress, setDataStress] = useState<any | null>(null);
    const [dataProductivity, setDataProductivity] = useState<any | null>(null);
    const [dataStDev, setDataStDev] = useState<any | null>(null);
    const [dataChange, setDataChange] = useState<any | null>(null);
    const [dataLoadingStress, setDataLoadingStress] = useState<boolean>(false);
    const [dataLoadingProductivity, setDataLoadingProductivity] = useState<boolean>(false);
    const [dataLoadingStDev, setDataLoadingStDev] = useState<boolean>(false);
    const [dataLoadingChange, setDataLoadingChange] = useState<boolean>(false);
    const [stressValue, setStressValue] = useState<number | null>(null);
    const [prodValue, setProdValue] = useState<number | null>(null);
    const [stDevValue, setStDevValue] = useState<number | null>(null);
    const [changeValue, setChangeValue] = useState<number | null>(null);

    const { current: cache} = useRef({});

    useEffect(() => {
        if(loading || !field) {
            return;
        }

        const definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('field'));

        if(!definition) {
            console.error('Unable to find field definition');
            return;
        }

        //const key = [field.ext_id!, settings[SETTING_SEASON_YEAR], metric].join("_");
        
        //if(!cache.hasOwnProperty(key)) {
            setDataLoadingStress(true);
            _load(field.ext_id!, settings[SETTING_SEASON_YEAR], "stress", definition).then(result => { 
                setDataStress(result);
                setDataLoadingStress(false);
                //cache[key] = result;
            });
            setDataLoadingProductivity(true);
            _load(field.ext_id!, settings[SETTING_SEASON_YEAR], "productivity", definition).then(result => { 
                setDataProductivity(result);
                setDataLoadingProductivity(false);
                //cache[key] = result;
            });
            _load_variance(field.ext_id!, settings[SETTING_SEASON_YEAR], "variability", definition).then(result => { 
                setDataStDev(result);
                setDataLoadingStDev(false);
                //cache[key] = result;
            });
            _load_variance_change(field.ext_id!, settings[SETTING_SEASON_YEAR], "variability", definition).then(result => { 
                setDataChange(result);
                setDataLoadingChange(false);
                //cache[key] = result;
            });
        /*} else {
            if(Object.keys(cache).length > CACHE_SIZE) {
                for(const k in cache) {
                    delete cache[k];
                }
            }
            setData(cache[key]);
        }*/
        setUpdateSelctorIncrement(prev => prev + 1);

    }, [loading, field, metric, settings[SETTING_SEASON_YEAR]]);

    useEffect(() => {
        //console.log("051524 dataProductivity", dataProductivity)
        console.log("051524 dataStress", dataStress)
        let tempStressValue = null;
        if (dataStress && dataStress.data && selectedDate) {
            let selectedDateIndex = dataStress.data.dates.findIndex((date:string) => date.startsWith(selectedDate));
            tempStressValue = dataStress.data.values[selectedDateIndex];
        }
        console.log("051524 tempStressValue", tempStressValue)
        setStressValue(tempStressValue);
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [dataStress, selectedDate]);

    useEffect(() => {
        console.log("051524 dataProductivity", dataProductivity)
        //console.log("051524 dataStress", dataStress)
        let tempProdValue = null;
        if (dataProductivity && dataProductivity.data && selectedDate) {
            let selectedDateIndex = dataProductivity.data.dates.findIndex((date:string) => date.startsWith(selectedDate));
            tempProdValue = dataProductivity.data.values[selectedDateIndex];
        }
        console.log("051524 tempProdValue", tempProdValue)
        setProdValue(tempProdValue);
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [dataProductivity, selectedDate]);

    useEffect(() => {
        console.log("G051524 dataStDev", dataStDev)
        //console.log("051524 dataStress", dataStress)
        let tempStDevValue = null;
        if (dataStDev && dataStDev.length && selectedDate) {
            let selectedDateIndex = dataStDev[0].dates.findIndex((date:string) => date.startsWith(selectedDate));
            tempStDevValue = dataStDev[0].values[selectedDateIndex];
        }
        console.log("G051524 tempStDevValue", tempStDevValue)
        setStDevValue(tempStDevValue);
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [dataStDev, selectedDate]);

    useEffect(() => {
        console.log("G051524 dataChange", dataChange)
        //console.log("051524 dataStress", dataStress)
        let tempChangeValue = null;
        if (dataChange && dataChange.length && selectedDate) {
            let selectedDateIndex = dataChange[0].dates.findIndex((date:string) => date.startsWith(selectedDate));
            tempChangeValue = dataChange[0].values[selectedDateIndex];
        }
        console.log("G051524 tempChangeValue", tempChangeValue)
        setChangeValue(tempChangeValue);
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [dataChange, selectedDate]);

    const _load = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwMetric(extId, definition, metric, dtStart, dtEnd);
        console.log("X111623 data", data)
        if(data) {
            let statValue: StatValue = {
                name: metric,
                metric: metric,
                date: data.dates[data.dates.length-1],
                value: data.values[data.values.length-1],
                min: Math.min(...data.values),
                max: Math.max(...data.values),
                prevValue: data.values.length > 1 ? data.values[data.values.length-2] : undefined,
                change: undefined,
                changeType: undefined,
                historical: data.values,
            };

            if(statValue.prevValue) {
                statValue.change = (statValue.value - statValue.prevValue) / statValue.prevValue * 100;
                statValue.changeType = statValue.change  && statValue.change > 0 ? 'increase' : 'decrease';
            }

            return {statValue: statValue, data:data};
        }

        return null;
    }

    const _load_variance = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwFieldVVIcVariance(extId, definition, metric, dtStart, dtEnd);
        console.log("X111623 data", data)
        if(data) {
            return data;
        }
        return null;
    }

    const _load_variance_change = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwFieldChange(extId, definition, metric, dtStart, dtEnd);
        console.log("E051524 data", data)
        if(data) {
            return data;
        }
        return null;
    }

    let _color = "#fff";
    let _backgroundColor = "#000";
    let _lineBackgroundColor =  "#e6e6e6";
    let _border = `1px solid #000`;
    let _borderBottom =  "0";
    let _borderTop = "1px solid #e6e6e6";

    return (<>
            <div
                style={{
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    backgroundColor: "#f7f7f7",
                    position: "relative",
                }}
                className="card mb-2"
            >
                <div
                    className="card-header">
                    Field ({field.name})
                </div>
                <div
                key={`selectorgrandparent_field_${updateSelctorIncrement}`}
                style={{
                    paddingBottom:"0px",
                    marginBottom:"0px",
                    border: "1px #e6e6e6 solid",
                    //borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
                >
                    <div
                        className="zone-stat-line"
                        key={`div_field_field_${updateSelctorIncrement}_field_selected`}
                        style={{
                            width:"100%",
                            height: "45px",
                            borderBottom: _borderBottom,
                            borderTop: _borderTop,
                            backgroundColor: _lineBackgroundColor,
                        }}
                    >
                        <div
                            key={`selector${updateSelctorIncrement}_field_selected`}
                            style={{
                                color: "none",//_color,
                                backgroundColor: "none",//_backgroundColor,
                                border: "none",//_border,
                                width:"35px",
                                height: "35px",
                                borderRadius: "20px",
                                fontWeight: "normal",
                                lineHeight: "35px",
                                textAlign: "center",
                                cursor:"pointer",
                                marginBottom: "0px",
                            }}
                            //onClick={() => setSelectedZone("field")}
                        >
                        </div>
                        <div className="zone-stat-stat" key={`vigor_field_${updateSelctorIncrement}_biomass_selector`}>
                            <div className="zone-stat-value">{prodValue ? dcRound(prodValue, undefined, undefined, true) : prodValue === 0 ? 0 : "n/a"}</div>
                            <div className="zone-stat-name">biomass</div>
                        </div>
                        <div className="zone-stat-stat" key={`stress_field_${updateSelctorIncrement}_stress_selector`}>
                            <div className="zone-stat-value">{stressValue ? dcRound(stressValue, undefined, undefined, true) : stressValue === 0 ? 0 : "n/a"}</div>
                            <div className="zone-stat-name">stress</div>
                        </div>
                        <div className="zone-stat-stat" key={`var_field_${updateSelctorIncrement}_stdev_selector`}>
                            <div className="zone-stat-value">{stDevValue ? dcRound(stDevValue, undefined, undefined, true) : stDevValue === 0 ? 0 : "n/a"}</div>
                            <div className="zone-stat-name">var</div>
                        </div>
                        <div className="zone-stat-stat" key={`change_field_${updateSelctorIncrement}_change_selector`}>
                            <div className="zone-stat-value">{changeValue ? dcRound(changeValue, undefined, undefined, true) : changeValue === 0 ? 0 : "n/a"}</div>
                            <div className="zone-stat-name">change</div>
                        </div>
                    </div>
                </div>

            </div>
            </>)
}

export default FieldStatTable;